export const REQUEST_STATUS = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    ERROR: 'ERROR',
};

export const SEARCH_RECORD_PAGE_LIMIT = 50;

export const DATE_TIME_FORMAT = {
    TIMEAGO: 'TIMEAGO',
    DATE: 'DD/MM/YYYY',
};
export const DATA_TYPE = {
    Decimal: 'Decimal',
    DATE: 'DD/MM/YYYY',
};

export const DEFAULT_DP = '/default-dp.png';

export default {
    REQUEST_STATUS,
    SEARCH_RECORD_PAGE_LIMIT,
    DATE_TIME_FORMAT,
    DEFAULT_DP,
    DATA_TYPE,
};
